export const FEATURES = {
  messageRedactor: true,
  jiraToolbelt: true,
  emAssistant: false,
  techDiagramAgent: false,
  safHub: false,
} as const

export type FeatureKey = keyof typeof FEATURES
